import { render, staticRenderFns } from "./WikiPublishConfig.vue?vue&type=template&id=6580236a"
import script from "./WikiPublishConfig.vue?vue&type=script&lang=ts"
export * from "./WikiPublishConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports